<template>
    <div>
        google.com, pub-4327755322079259, DIRECT, f08c47fec0942fa0

        vungle.com,65ed0a8e17069f0011a3cdea,DIRECT,c107d686becd2d77
        33across.com,0015a00002egvRSAAY,RESELLER,bbea06d9c4d2853c
        Contextweb.com,562852,RESELLER,89ff185a4c4e857c
        Media.net,8CU12AQ1Y,RESELLER
        adelement.com,30208,RESELLER
        adform.com,2742,RESELLER
        adform.com,3083,RESELLER
        adform.com,3119,RESELLER,9f5210a2f0999e32
        adiiix.com,3d9335d3,RESELLER
        adiiix.com,par-AA7B236BA32DD484C838E249362437B8,RESELLER
        adingo.jp,31054,RESELLER
        admanmedia.com,20,RESELLER
        admanmedia.com,990,RESELLER
        admixer.co.kr,1094,RESELLER
        admixer.co.kr,1610,RESELLER
        admixer.co.kr,1654,RESELLER
        adtiming.com,a-126,RESELLER,bf66753b8f380142
        adview.com,06667060,RESELLER,1b2cc038a11ea319
        adview.com,32076181,RESELLER,1b2cc038a11ea319
        advlion.com,3117,RESELLER
        adyoulike.com,78afbc34fac571736717317117dfa247,RESELLER
        adyoulike.com,994b7b4e03898048761c7110f11e56c2,RESELLER
        aniview.com,603f65a2e291680ef30af9c7,RESELLER,78b21b97965ec3f8
        app-stock.com,343264,RESELLER
        appnexus.com,11826,RESELLER
        appnexus.com,11924,RESELLER,f5ab79cb980f11d1
        appnexus.com,13293,RESELLER
        appnexus.com,13297,RESELLER,f5ab79cb980f11d1
        appnexus.com,13709,RESELLER,f5ab79cb980f11d1
        appnexus.com,15349,RESELLER,f5ab79cb980f11d1
        appnexus.com,15426,RESELLER,f5ab79cb980f11d1
        appnexus.com,1752,RESELLER,f5ab79cb980f11d1
        appnexus.com,4052,RESELLER
        appnexus.com,7351,RESELLER,f5ab79cb980f11d1
        appnexus.com,7597,RESELLER,f5ab79cb980f11d1
        appnexus.com,9316,RESELLER,f5ab79cb980f11d1
        aralego.com,par-AA7B236BA32DD484C838E249362437B8,RESELLER
        aralego.com,par-D2346AAB7ABD36B4CDD7BBD264BA92E2,RESELLER
        bematterfull.com,22289765,RESELLER
        betweendigital.com,43843,RESELLER
        betweendigital.com,43860,RESELLER
        betweendigital.com,44917,RESELLER
        betweendigital.com,45270,RESELLER
        bidence.com,d35302328a4b1f129d376f9c2932b0b7,RESELLER
        bidmachine.io,147,RESELLER
        bidmachine.io,148,RESELLER
        bidmachine.io,189,RESELLER
        bidmachine.io,190,RESELLER
        bidmachine.io,77,RESELLER
        blueseasx.com,203592,RESELLER,7998eac5087f6110
        caerulus.io,3320-72775,RESELLER
        consumable.com,2001409,RESELLER,aefcd3d2f45b5070
        consumable.com,2001585,RESELLER,aefcd3d2f45b5070
        contextweb.com,558622,RESELLER,89ff185a4c4e857c
        contextweb.com,562546,RESELLER,89ff185a4c4e857c
        contextweb.com,562569,RESELLER,89ff185a4c4e857c
        contextweb.com,562615,RESELLER,89ff185a4c4e857c
        contextweb.com,562762,RESELLER,89ff185a4c4e857c
        contextweb.com,562791,RESELLER,89ff185a4c4e857c
        contextweb.com,562824,RESELLER,89ff185a4c4e857c
        contextweb.com,562827,RESELLER,89ff185a4c4e857c
        contextweb.com,563539,RESELLER,89ff185a4c4e857c
        contextweb.com,563601,RESELLER,89ff185a4c4e857c
        conversantmedia.com,100242,RESELLER,03113cd04947736d
        conversantmedia.com,100246,RESELLER,03113cd04947736d
        conversantmedia.com,100269,RESELLER,03113cd04947736d
        conversantmedia.com,100358,RESELLER,03113cd04947736d
        conversantmedia.com,100863,RESELLER,03113cd04947736d
        criteo.com,B-057601,RESELLER,9fac4a4a87c2a44f
        criteo.com,B-074375,RESELLER,9fac4a4a87c2a44f
        display.io,173162,RESELLER
        e-planning.net,081dcb996d2ccc1e,RESELLER,c1ba615865ed87b2
        eliteappgrade.com,494223,RESELLER
        equativ.com,5026,RESELLER,060d053dcf45cbf3
        freewheel.tv,1137745,RESELLER
        freewheel.tv,1138513,RESELLER
        freewheel.tv,1157729,RESELLER
        freewheel.tv,1157777,RESELLER
        freewheel.tv,1590601,RESELLER
        freewheel.tv,1590606,RESELLER
        fromthetop.io,65536,RESELLER
        gitberry.com,405100012,RESELLER
        gitberry.com,90scb,RESELLER
        google.com,pub-7214269347534569,RESELLER,f08c47fec0942fa0
        growintech.co,2723d092b63885e0d7c260cc007e8b9d2393g,RESELLER,9d8dfe5c6b00fb37
        hindsightsolutions.net,323-b5738,RESELLER,20e30b2ae1f670f2
        improvedigital.com,1795,RESELLER
        improvedigital.com,2450,RESELLER
        improvedigital.com,2451,RESELLER
        indexexchange.com,183920,RESELLER,50b1c356f2c5c8fc
        inmobi.com,12a9a79d60214a40a444a6103b81747c,RESELLER,83e75a7ae333ca9d
        inmobi.com,22e5354e453f49348325184e25464adb,RESELLER,83e75a7ae333ca9d
        inmobi.com,23800006c42e4a739966c05ca0ac4854,RESELLER,83e75a7ae333ca9d
        inmobi.com,2ce1d976516340a49b12e59749659864,RESELLER,83e75a7ae333ca9d
        inmobi.com,38e36193f3c944d0b6254c71e511041b,RESELLER,83e75a7ae333ca9d
        inmobi.com,55049d2e109d4ac1820ca1432dda4e13,RESELLER,83e75a7ae333ca9d
        inmobi.com,5d2c913a0c5f4142acc7412723ee15d7,RESELLER,83e75a7ae333ca9d
        inmobi.com,867c89bb53994aaeb9dae3ce75b03e78,RESELLER,83e75a7ae333ca9d
        inmobi.com,9e311c7a68e94888aac7fbb4272381e2,RESELLER
        inmobi.com,ab915bcef5b24940bf745f1a8f427bec,RESELLER,83e75a7ae333ca9d
        inmobi.com,c1e6d3502da64ebaa3ad0e4a4be15f11,RESELLER,83e75a7ae333ca9d
        inmobi.com,ddb41d8a9f434a918d05a0fc9999d9f9,RESELLER,83e75a7ae333ca9d
        inmobi.com,e2ce6fad847d4642b368082d662cc088,RESELLER,83e75a7ae333ca9d
        inmobi.com,ec6f6ceb8bb1440ba5455644ec96c275,RESELLER,83e75a7ae333ca9d
        inmobi.com,f3924290136e4129a5c082ff982c3a58,RESELLER,83e75a7ae333ca9d
        inmobi.com,f71b28e30a8249c3b08a9bca1a5cfbb7,RESELLER,83e75a7ae333ca9d
        iqzone.com,IQ39,RESELLER
        iqzone.com,IQ97,RESELLER
        kidoz.net,15127,RESELLER,a109366414b7335e
        lijit.com,400766,RESELLER,fafdf38b16bf6b2b
        lijit.com,481366,RESELLER,fafdf38b16bf6b2b
        lijit.com,488437,RESELLER,fafdf38b16bf6b2b
        lijit.com,500520,RESELLER,fafdf38b16bf6b2b
        lijit.com,503707,RESELLER,fafdf38b16bf6b2b
        lijit.com,512156,RESELLER,fafdf38b16bf6b2b
        lijit.com,512908,RESELLER,fafdf38b16bf6b2b
        lijit.com,530498,RESELLER,fafdf38b16bf6b2b
        loopme.com,10999,RESELLER,6c8d5f95897a5a3b
        loopme.com,11322,RESELLER,6c8d5f95897a5a3b
        loopme.com,11362,RESELLER,6c8d5f95897a5a3b
        loopme.com,11414,RESELLER,6c8d5f95897a5a3b
        loopme.com,2896,RESELLER,6c8d5f95897a5a3b
        loopme.com,9718,RESELLER,6c8d5f95897a5a3b
        lunamedia.io,95ed51edc1cb499baaf3476fcb6fa463,RESELLER,524ecb396915caaf
        mars.media,1010422,RESELLER,8624339f102fb076
        mars.media,107876,RESELLER,8624339f102fb076
        media.net,8CUN37DCC,RESELLER
        media.net,8CUP1N1F2,RESELLER
        meitu.com,755,RESELLER
        mintegral.com,10026,RESELLER
        mintegral.com,10030,RESELLER
        mman.kr,30769,RESELLER
        mobupps.com,c74d97b01eae257e44aa9d5bade97baf32954,RESELLER
        mobupps.com,c74d97b01eae257e44aa9d5bade97baf7726,RESELLER
        onetag.com,8668c16092f01e8,RESELLER,0bfd66d529a55807
        onetag.com,8dd8de7f341d57e,RESELLER
        onlinemediasolutions.com,20444,RESELLER
        openx.com,537149888,RESELLER,6a698e2ec38604c6
        openx.com,537152826,RESELLER,6a698e2ec38604c6
        openx.com,539472296,RESELLER,6a698e2ec38604c6
        openx.com,540031703,RESELLER,6a698e2ec38604c6
        openx.com,540280728,RESELLER,6a698e2ec38604c6
        openx.com,540326226,RESELLER,6a698e2ec38604c6
        openx.com,540421297,RESELLER,6a698e2ec38604c6
        openx.com,540543195,RESELLER,6a698e2ec38604c6
        openx.com,540646187,RESELLER
        openx.com,540679900,RESELLER,6a698e2ec38604c6
        openx.com,540838151,RESELLER,6a698e2ec38604c6
        openx.com,541031350,RESELLER,6a698e2ec38604c6
        openx.com,544096208,RESELLER,6a698e2ec38604c6
        openx.com,561436793,RESELLER,6a698e2ec38604c6
        opera.com,pub4366595624320,RESELLER,55a0c5fd61378de3
        opera.com,pub4444433466368,RESELLER,55a0c5fd61378de3
        opera.com,pub5925993551616,RESELLER,55a0c5fd61378de3
        pangleglobal.com,82832,RESELLER
        playdigo.com,1986,RESELLER,92011346d63d3c30
        playdigo.com,2041,RESELLER,92011346d63d3c30
        pokkt.com,5886,RESELLER,c45702d9311e25fd
        prado.co,15127,RESELLER
        programmaticx.ai,6888889,RESELLER
        pubmatic.com,156177,RESELLER,5d62403b186f2ace
        pubmatic.com,156425,RESELLER,5d62403b186f2ace
        pubmatic.com,156517,RESELLER,5d62403b186f2ace
        pubmatic.com,156520,RESELLER,5d62403b186f2ace
        pubmatic.com,156631,RESELLER,5d62403b186f2ace
        pubmatic.com,156835,RESELLER,5d62403b186f2ace
        pubmatic.com,156931,RESELLER,5d62403b186f2ace
        pubmatic.com,157097,RESELLER,5d62403b186f2ace
        pubmatic.com,157559,RESELLER,5d62403b186f2ace
        pubmatic.com,157654,RESELLER,5d62403b186f2ace
        pubmatic.com,157800,RESELLER,5d62403b186f2ace
        pubmatic.com,158060,RESELLER,5d62403b186f2ace
        pubmatic.com,158100,RESELLER,5d62403b186f2ace
        pubmatic.com,158154,RESELLER,5d62403b186f2ace
        pubmatic.com,158271,RESELLER,5d62403b186f2ace
        pubmatic.com,158408,RESELLER,5d62403b186f2ace
        pubmatic.com,159035,RESELLER,5d62403b186f2ace
        pubmatic.com,159277,RESELLER
        pubmatic.com,159501,RESELLER,5d62403b186f2ace
        pubmatic.com,159668,RESELLER
        pubmatic.com,159846,RESELLER,5d62403b186f2ace
        pubmatic.com,160113,RESELLER,5d62403b186f2ace
        pubmatic.com,160145,RESELLER,5d62403b186f2ace
        pubmatic.com,160194,RESELLER,5d62403b186f2ace
        pubmatic.com,160195,RESELLER,5d62403b186f2ace
        pubmatic.com,160692,RESELLER,5d62403b186f2ace
        pubmatic.com,160974,RESELLER,5d62403b186f2ace
        pubmatic.com,161136,RESELLER,5d62403b186f2ace
        pubmatic.com,161162,RESELLER,5d62403b186f2ace
        pubmatic.com,161267,RESELLER,5d62403b186f2ace
        pubmatic.com,161372,RESELLER,5d62403b186f2ace
        pubmatic.com,161748,RESELLER,5d62403b186f2ace
        pubmatic.com,162223,RESELLER,5d62403b186f2ace
        pubmatic.com,162882,RESELLER,5d62403b186f2ace
        pubmatic.com,162974,RESELLER,5d62403b186f2ace
        pubmatic.com,163319,RESELLER,5d62403b186f2ace
        pubmatic.com,163476,RESELLER,5d62403b186f2ace
        pubmatic.com,164532,RESELLER,5d62403b186f2ace
        pubmatic.com,165117,RESELLER,5d62403b186f2ace
        pubmatic.com,165438,RESELLER,5d62403b186f2ace
        pubmatic.com,166078,RESELLER,5d62403b186f2ace
        pubnative.net,1007249,RESELLER,d641df8625486a7b
        pubnative.net,1007262,RESELLER,d641df8625486a7b
        pubnative.net,1007303,RESELLER,d641df8625486a7b
        pubnative.net,1007475,RESELLER,d641df8625486a7b
        pubnative.net,1007501,RESELLER,d641df8625486a7b
        pubnative.net,1009029,RESELLER,d641df8625486a7b
        pubnative.net,1009988,RESELLER,d641df8625486a7b
        pubwise.io,52324626,RESELLER,c327c91a93a7cdd3
        rhebus.works,9176497567,RESELLER
        rhythmone.com,5336134699710583737,RESELLER,a670c89d4a324e47
        risecodes.com,662a26f1f3d42a00015ffbad,RESELLER
        rubiconproject.com,11726,RESELLER,0bfd66d529a55807
        rubiconproject.com,12186,RESELLER,0bfd66d529a55807
        rubiconproject.com,12266,RESELLER,0bfd66d529a55807
        rubiconproject.com,12556,RESELLER,0bfd66d529a55807
        rubiconproject.com,13132,RESELLER,0bfd66d529a55807
        rubiconproject.com,13856,RESELLER,0bfd66d529a55807
        rubiconproject.com,14558,RESELLER,0bfd66d529a55807
        rubiconproject.com,15268,RESELLER
        rubiconproject.com,15278,RESELLER,0bfd66d529a55807
        rubiconproject.com,16114,RESELLER,0bfd66d529a55807
        rubiconproject.com,16834,RESELLER,0bfd66d529a55807
        rubiconproject.com,17328,RESELLER,0bfd66d529a55807
        rubiconproject.com,17608,RESELLER,0bfd66d529a55807
        rubiconproject.com,18202,RESELLER,0bfd66d529a55807
        rubiconproject.com,18364,RESELLER,0bfd66d529a55807
        rubiconproject.com,20050,RESELLER,0bfd66d529a55807
        rubiconproject.com,20744,RESELLER,0bfd66d529a55807
        rubiconproject.com,23644,RESELLER,0bfd66d529a55807
        rubiconproject.com,23980,RESELLER,0bfd66d529a55807
        rubiconproject.com,24170,RESELLER,0bfd66d529a55807
        rubiconproject.com,24362,RESELLER,0bfd66d529a55807
        rubiconproject.com,24400,RESELLER,0bfd66d529a55807
        rubiconproject.com,24448,RESELLER,0bfd66d529a55807
        rubiconproject.com,24600,RESELLER,0bfd66d529a55807
        rubiconproject.com,24752,RESELLER,0bfd66d529a55807
        rubiconproject.com,25386,RESELLER,0bfd66d529a55807
        rubiconproject.com,25872,RESELLER,0bfd66d529a55807
        rubiconproject.com,25978,RESELLER,0bfd66d529a55807
        rubiconproject.com,26064,RESELLER,0bfd66d529a55807
        rubiconproject.com,26132,RESELLER,0bfd66d529a55807
        rubiconproject.com,26292,RESELLER,0bfd66d529a55807
        rubiconproject.com,26846,RESELLER,0bfd66d529a55807
        rubiconproject.com,26958,RESELLER,0bfd66d529a55807
        sharethrough.com,6qlnf8SY,RESELLER,d53b998a7bd4ecd2
        sharethrough.com,DQQogebZ,RESELLER,d53b998a7bd4ecd2
        sharethrough.com,NIRSC9f2,RESELLER,d53b998a7bd4ecd2
        sharethrough.com,UbYLkrys,RESELLER,d53b998a7bd4ecd2
        sharethrough.com,XeKuhSkz,RESELLER,d53b998a7bd4ecd2a
        sharethrough.com,ZqrIAHsE,RESELLER,d53b998a7bd4ecd2
        sharethrough.com,bXzzb1bR,RESELLER,d53b998a7bd4ecd2
        showheroes.com,6031,RESELLER
        singularads.com,548745,RESELLER
        smaato.com,1100004890,RESELLER,07bcf65f187117b4
        smaato.com,1100044045,RESELLER,07bcf65f187117b4
        smaato.com,1100049757,RESELLER,07bcf65f187117b4
        smaato.com,1100051149,RESELLER,07bcf65f187117b4
        smaato.com,1100052485,RESELLER,07bcf65f187117b4
        smaato.com,1100056110,RESELLER,07bcf65f187117b4
        smartadserver.com,1692,RESELLER
        smartadserver.com,3117,RESELLER
        smartadserver.com,3232,RESELLER
        smartadserver.com,3713,RESELLER
        smartadserver.com,3797,RESELLER
        smartadserver.com,3817,RESELLER
        smartadserver.com,4111,RESELLER
        smartadserver.com,4140,RESELLER
        smartadserver.com,4210,RESELLER,060d053dcf45cbf3
        smartadserver.com,4284,RESELLER
        smartadserver.com,4383,RESELLER
        smartadserver.com,4457,RESELLER,060d053dcf45cbf3
        smartadserver.com,4467,RESELLER
        smartadserver.com,4569,RESELLER
        smartadserver.com,4625,RESELLER,060d053dcf45cbf3
        smartadserver.com,4762,RESELLER,060d053dcf45cbf3
        smartadserver.com,4865,RESELLER
        smartadserver.com,4880,RESELLER,060d053dcf45cbf3
        smartadserver.com,5026,RESELLER,060d053dcf45cbf3
        smartclip.net,14275,RESELLER
        smartclip.net,27985,RESELLER
        smartstream.tv,679,RESELLER
        smartyads.com,100115,RESELLER,fd2bde0ff2e62c5d
        smartyads.com,100149,RESELLER,fd2bde0ff2e62c5d
        smartyads.com,368,RESELLER
        sonobi.com,4a289cdd79,RESELLER,d1a215d9eb5aee9e
        sonobi.com,5b003395a5,RESELLER,d1a215d9eb5aee9e
        sonobi.com,a257177742,RESELLER,d1a215d9eb5aee9e
        sonobi.com,b43e9530e7,RESELLER,d1a215d9eb5aee9e
        sonobi.com,d2b13d1c36,RESELLER,d1a215d9eb5aee9e
        spotxchange.com,283422,RESELLER,7842df1d2fe2db34
        spotxchange.com,82068,RESELLER,7842df1d2fe2db34
        ssp.e-volution.ai,AJxF6R118a9M6CaTvK,RESELLER
        ssp.e-volution.ai,AJxF6R189a9M6CaTvK,RESELLER
        ssp.e-volution.ai,AJxF6R396a9M6CaTvK,RESELLER
        start.io,162328800,RESELLER
        target.my.com,8676470,RESELLER
        targetspot.com,297,RESELLER,feb28ed826dcf532
        thebrave.io,1234632,RESELLER,c25b2154543746ac
        thebrave.io,1234633,RESELLER,c25b2154543746ac
        themediagrid.com,A8X5S7,RESELLER,35d5010d7789b49d
        themediagrid.com,DY1OVP,RESELLER,35d5010d7789b49d
        themediagrid.com,SWH94X,RESELLER,35d5010d7789b49d
        themediagrid.com,SYMTFD,RESELLER,35d5010d7789b49d
        thunder-monetize.com,2297825074,RESELLER
        tpmn.io,532,RESELLER
        tradplusad.com,97f87d32cbc437a3,RESELLER
        tremorhub.com,s92od-u4sw5,RESELLER,1a4e959a1b50034a
        triplelift.com,11656,RESELLER,6c33edb13117fd86
        triplelift.com,12456,RESELLER,6c33edb13117fd86
        triplelift.com,12908,RESELLER,6c33edb13117fd86
        triplelift.com,13043,RESELLER,6c33edb13117fd86
        ucfunnel.com,par-AA7B236BA32DD484C838E249362437B8,RESELLER
        ucfunnel.com,par-D2346AAB7ABD36B4CDD7BBD264BA92E2,RESELLER
        unrulymedia.com,2464975885,RESELLER
        unrulymedia.com,689559416,RESELLER
        verve.com,14619,RESELLER,0c8f5958fc2d6270
        verve.com,15503,RESELLER,0c8f5958fc2d6270
        video.unrulymedia.com,123476257,RESELLER
        video.unrulymedia.com,169764768,RESELLER
        video.unrulymedia.com,2099898025,RESELLER
        video.unrulymedia.com,2613193077,RESELLER
        video.unrulymedia.com,3704396951,RESELLER
        video.unrulymedia.com,3855144660485329163,RESELLER
        video.unrulymedia.com,3948367200,RESELLER
        video.unrulymedia.com,4201299756,RESELLER
        video.unrulymedia.com,4268206200,RESELLER
        video.unrulymedia.com,4631344382657206988,RESELLER
        video.unrulymedia.com,5127265468568773826,RESELLER
        video.unrulymedia.com,5336134699710583737,RESELLER
        video.unrulymedia.com,689559416,RESELLER
        video.unrulymedia.com,755432070,RESELLER
        video.unrulymedia.com,906352066,RESELLER
        video.unrulymedia.com,947824792,RESELLER
        videoheroes.tv,212428,RESELLER,064bc410192443d8
        videoheroes.tv,212459,RESELLER,064bc410192443d8
        vidoomy.com,2412786,RESELLER
        vidoomy.com,9148331,RESELLER
        visiblemeasures.com,1020,RESELLER
        webeyemob.com,70628,RESELLER
        webeyemob.com,80609,RESELLER
        xad.com,241,RESELLER,81cbf0a75a5e0e9a
        xandr.com,10128,RESELLER,f5ab79cb980f11d1
        xandr.com,12745,RESELLER,f5ab79cb980f11d1
        xandr.com,13238,RESELLER,f5ab79cb980f11d1
        xandr.com,13297,RESELLER,f5ab79cb980f11d1
        xandr.com,13799,RESELLER
        xandr.com,15426,RESELLER,f5ab79cb980f11d1
        xandr.com,15840,RESELLER
        yeahmobi.com,114122,RESELLER
        yeahmobi.com,5135224,RESELLER
        yieldmo.com,2754490424016969782,RESELLER
        yieldmo.com,3591550211052216798,RESELLER,6a92c77cfc3d2258
        zetaglobal.net,757,RESELLER
        zetaglobal.net,815,RESELLER
        zetaglobal.net,998,RESELLER
        zmaticoo.com,5135224,RESELLER
        zoomd.com,88478941,RESELLER
    </div>
</template>

<script>
export default {
    name: "AppAdsTxtScreen",
}
</script>